const React = require('react')
require('@styles/components/common/card.style.css')

const CustomCard = props => {
    const { style, className } = props
    return (
        <div style={style} className={`${className} custom-card`}>
            {props.children}
        </div>
    )
}

const CustomCardHeader = props => {
    const { className } = props
    return <div className={`${className} custom-card-header`}>{props.children}</div>
}

const CustomCardBody = props => {
    const { className } = props
    return <div className={`${className} custom-card-body`}>{props.children}</div>
}

const CustomCardFooter = props => {
    const { className } = props
    return <div className={`${className} custom-card-footer`}>{props.children}</div>
}

module.exports = {
    CustomCard,
    CustomCardHeader,
    CustomCardBody,
    CustomCardFooter
}
